import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Modal, Row, Button } from 'react-bootstrap';
import APICom from '../../utils/helpers/APICom';
import {Icon} from '@iconify/react';
import { useSelector } from "react-redux";

const ShowRoutes = (props) => {

    const { loginData } = useSelector((store) => store.login);
    const [routeAlertObj, setRouteAlertObj] = useState({ alertTitle: '', alertMsg: '', displayFooter:true });
    const [showRouteAlert, setRouteAlert] = useState(false);
    const [TableHeaders, setTableHeaders] = useState(["Route","Locked","Block","UnLocked", "Open"]);
    const [showTableCols, setShowTableCols] = useState(false);
    const [ShowLoader, setShowLoader] = useState(false);
    const [showInfoWindow, setShowInfoWindow] = useState(false);
    const [routeDisplay, setRouteDisplay] = useState({});
    const [NoOfGroup, setNoOfGroup] = useState(-1);
    const [ARBRoutes, setARBRoutes] = useState([]);
    const [ARBRoutesSelection, setARBRoutesSelection] = useState([]);
    const xCancelSourceForGrid = useRef(null);
    const infoWindowText = useRef(<><span className="position-absolute" onMouseLeave={(e)=>{e.target.className="position-absolute"}} onMouseOver={(e)=>{e.target.className="position-absolute fw-bold"}} onClick={(e)=>setShowInfoWindow(false)} style={{cursor:"pointer", right:"2%", fontSize:"medium", marginTop:"-1%"}}>X</span><p className="m-0"><b style={{textDecoration:"underline"}}>Locked</b>: ARB will not add trips or change stop order within the locked route.
    <br></br><b style={{textDecoration:"underline"}}>Block</b>: ARB may add trips before or after blocked cluster. ARB will not add trips or change stop order with in the blocked cluster.
    <br></br><b style={{textDecoration:"underline"}}>UnLocked</b>: ARB may add more trips or change stop order with in the unlocked cluster.
    <br></br><b style={{textDecoration:"underline"}}>Open</b>: ARB may add, remove trips, or change stop order of the open route</p></>);

    useEffect(() => {
        const distinctGroup = [...new Set(props.GridRowData
            .map(data => data.Group)
            .filter(Group => Group)
        )];
        setNoOfGroup(distinctGroup.length);

        handleRouteTableDisplay();
        
    }, []);

    const handleRouteAlertClose = () =>{
        props.setShowRoutesDialog(false);
        setRouteAlert(false);
    }


    const handleRouteTableDisplay = async(e)=>{
        try{
            setShowLoader(true);
            let affID = parseInt((props.selectedAffiliates.includes(",")?props.selectedAffiliates.split(",")[0]:props.selectedAffiliates));
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetManifestARBRestriction?selected_date=" + props.selectedDate + "&affiliate_id=" + affID
                , "get", { "Content-Type": "application/json" }, null, null);
            if(response.data !== null && response.data.length > 0)
            {
                let restrictions = [];
                let dict = {};
                for(let k = 0; k < response.data.length; k++)
                {
                    dict = {};
                    dict[response.data[k].manifest_number] = response.data[k].arb_restrictions;
                    restrictions.push(dict);
                }
                setARBRoutesSelection(restrictions);
                setShowLoader(false);
                setRouteDisplay(response.data);
                setShowTableCols(true);
                setARBRoutes(response.data);
            }
            else
            {
                if(response.error.length > 0)
                {
                    setShowLoader(false);
                    setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Route Restrictions Alert', alertMsg: response.error , displayFooter: true});
                    setRouteAlert(true);
                }
                else
                {
                    setShowLoader(false);
                    setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Route Restrictions Alert', alertMsg: 'No routes are found!' , displayFooter: true});
                    setRouteAlert(true);
                }
            }
        }
        catch(err){console.log(err);}
            
    };

    const handleApplyRoutesSetting = async()=>{
        try{
            xCancelSourceForGrid.current = APICom.GenerateSource();
            let routesInfoDict = {};
            let combinedData = [];
            for(let i = 0; i < ARBRoutes.length; i++)
            {
                routesInfoDict = {};
                routesInfoDict["manifest_number"] = ARBRoutes[i].manifest_number;
                routesInfoDict["restriction"] = ARBRoutesSelection[i][ARBRoutes[i].manifest_number];
                combinedData.push(routesInfoDict);
            }
            let data = {
                "combined_data": combinedData,
                "modified_user_id": loginData.iUserID,
                "modified_app_id": 26
            }
            setShowLoader(true);
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/Routing/UpdateManifestARBRestriction", "post", {}, data, xCancelSourceForGrid.current);
            // console.log(response);
            if(response.data !== null && response.data.length > 0)
            {
                // props.setShowRoutesDialog(false);
                if(response.data[0].Item2.length > 0)
                {
                    setShowLoader(false);
                    setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Update Route Restrictions Alert', alertMsg: "There was an issue with the update, please try again later." , displayFooter: true});
                    setRouteAlert(true);
                }
                else
                {
                    setShowLoader(false);
                    setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Update Route Restrictions Alert', alertMsg: "Update was successful!" , displayFooter: true});
                    setRouteAlert(true);
                }
                
            }
            else
            {
                if(response.error.length > 0)
                {
                    setShowLoader(false);
                    setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Update Route Restrictions Alert', alertMsg: response.error , displayFooter: true});
                    setRouteAlert(true);
                }
                else
                {
                    setShowLoader(false);
                    setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Update Route Restrictions Alert', alertMsg: 'Please contact the backend office' , displayFooter: true});
                    setRouteAlert(true);
                }
            }
        }
        catch(err){console.log(err);}
    };

    const handleRadioChecked = (index, manifestID, restriction)=>{
        setARBRoutesSelection(prevState=>{
            const newState = {...prevState};
            newState[index][manifestID] = restriction;
            return newState;
        });
    };

    const handleFilteringRoutes = (e)=>{
        let elements = document.getElementsByClassName('routeRestrictionList');
        
        for(var k = 0; k < elements.length; k++)
        {
            if(!elements[k].children[0].textContent.toLowerCase().includes(e.target.value.toLowerCase()))
            {
                elements[k].style.display = "none";
            }
            else
            {
                elements[k].style.display = "table-row";
            }
        }
    };

    return (
        <>
            <Modal show={props.showRoutesDialog ? 1 : 0} centered onHide={()=>{props.setShowRoutesDialog(false);}} size="lg"
                aria-labelledby="contained-modal-title-vcenter" animation={true} keyboard={true} backdrop="static">
                <Modal.Header className='dispatch_action_dialog_header_bgcolor' closeButton>
                    <Modal.Title className='dispatch_action_dialog_title_color user-select-none' id="contained-modal-title-vcenter">
                        Route Restrictions <Icon name={"routeRestrictionIcon"} className={"float-end"} onClick={(e)=>setShowInfoWindow(true)} style={{cursor:"pointer",fontSize:"medium"}} icon="bx:help-circle"/>
                        {showInfoWindow?<div className="position-absolute d-inline-flex bg-light float-end p-2 mx-2 my-0 mt-1 text-dark rounded border" style={{zIndex:"999999", fontSize:"small"}}>{infoWindowText.current}</div>:""}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="grid-example">
                    <Container>
                        {/*<Row>
                            <Col md={3} className="w-100">
                                <span className="user-select-none float-start">For Trip: <b className="mx-2">{props.GridRowData.length > 1 ? props.GridRowData.length + " trips selected" : props.GridRowData[0]["ConfirmationNo"]}</b></span>
                                <span className="firstRow text-nowrap user-select-none float-end"> Number of Groups: <b className="mx-2">{NoOfGroup}</b></span>
                            </Col>
                        </Row>*/}
                        {ShowLoader ? <div className="loader"></div> : ""}
                        
                        {showTableCols ? 
                            <Row className="mt-1 overflow-auto" style={{height:"300px"}}>
                                
                                <Col className="justify-content-center">
                                    <table className="w-100 border border-dark">
                                        <thead>
                                            <tr className="text-center text-nowrap">
                                                {TableHeaders.map((head, headID) =>{
                                                    if(head === "Route")
                                                    {
                                                        return <th className="border border-dark p-1 user-select-none" key={headID}>{head}<input type="text" placeholder="Route Number..." onKeyUp={handleFilteringRoutes} className="d-block w-100 text-center"/></th>;
                                                    }
                                                    else
                                                    {
                                                        return <th className="border border-dark p-1 user-select-none" key={headID}>{head}</th>;
                                                    }
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {routeDisplay.map((item, index)=>(
                                                <tr key={index} className="text-center routeRestrictionList">
                                                    <td value={item.manifest_number} className="border border-dark user-select-none">{item.route_number}</td>
                                                    <td className="border border-dark"><input name={item.manifest_number+"radio_btn"} checked={ARBRoutesSelection[index][item.manifest_number]==="locked"} onChange={(e)=>handleRadioChecked(index, item.manifest_number, e.target.value)} style={{cursor:"pointer"}} value={"locked"} type="radio"/></td>
                                                    <td className="border border-dark"><input name={item.manifest_number+"radio_btn"} checked={ARBRoutesSelection[index][item.manifest_number]==="block"} disabled={!item.have_pending_trips} onChange={(e)=>handleRadioChecked(index, item.manifest_number, e.target.value)}  style={{cursor:"pointer"}} value={"block"} type="radio"/></td>
                                                    <td className="border border-dark"><input name={item.manifest_number+"radio_btn"} checked={ARBRoutesSelection[index][item.manifest_number]==="un_locked"} disabled={!item.have_pending_trips} onChange={(e)=>handleRadioChecked(index, item.manifest_number, e.target.value)}  style={{cursor:"pointer"}} value={"un_locked"} type="radio"/></td>
                                                    <td className="border border-dark"><input name={item.manifest_number+"radio_btn"} checked={ARBRoutesSelection[index][item.manifest_number]==="none"} onChange={(e)=>handleRadioChecked(index, item.manifest_number, e.target.value)} style={{cursor:"pointer"}} value={"none"} type="radio"/></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>:""
                        }
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="dark" title="Apply Routes Setting" onClick={handleApplyRoutesSetting} disabled={!showTableCols}>Apply</Button>
                    <Button variant="dark" onClick={()=>{props.setShowRoutesDialog(false);}}>Close</Button>
                </Modal.Footer>
            </Modal>

            {showRouteAlert && <Modal centered show={showRouteAlert} onHide={handleRouteAlertClose} >
                <Modal.Header closeButton>
                    <Modal.Title>{routeAlertObj.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{routeAlertObj.alertMsg}</b></Modal.Body>
                {routeAlertObj.displayFooter?
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleRouteAlertClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                :""}
            </Modal>}
        </>
    );
}

export default ShowRoutes;